import React from 'react'

import { Moment } from 'moment'

import { observer } from 'mobx-react'

import type Store from 'modules/attendance/components/ClockIn/Store'
import { SidePanelTab } from 'modules/attendance/lib/sidepanelTabTypes'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'

import BankOfHoursBreakdownPanel from './BankOfHoursBreakdownPanel'
import BreakdownPanel from './BreakdownPanel'
import CompensationPannel from './CompensationPannel'

type Props = {
  tabFromNavigation: SidePanelTab
  timeSheetDate: Moment
  employeeId: number
  store: Store
}

const TabsBreakdown = ({ tabFromNavigation, timeSheetDate, employeeId, store }: Props) => {
  const timesheetData = useTimesheetData()
  const { featureByName } = timesheetData
  const bankOfHoursEnabled = TimesheetFeatures.BANK_OF_HOURS in featureByName
  const compensationFlowV2Enabled = TimesheetFeatures.COMPENSATION_FLOW_V2 in featureByName

  if (compensationFlowV2Enabled && tabFromNavigation === 'compensation') {
    return (
      <CompensationPannel
        tabFromNavigation={tabFromNavigation}
        timeSheetData={timesheetData}
        timeSheetDate={timeSheetDate}
        employeeId={Number(employeeId)}
      />
    )
  } else if (bankOfHoursEnabled) {
    return (
      <BankOfHoursBreakdownPanel
        tabFromNavigation={tabFromNavigation}
        timeSheetData={timesheetData}
        timeSheetDate={timeSheetDate}
        employeeId={Number(employeeId)}
        store={store}
      />
    )
  } else {
    return (
      <BreakdownPanel
        tabFromNavigation={tabFromNavigation}
        timeSheetData={timesheetData}
        timeSheetDate={timeSheetDate}
        employeeId={Number(employeeId)}
        store={store}
      />
    )
  }
}

export default observer(TabsBreakdown)
